import { Component, OnDestroy, OnInit } from '@angular/core';
import { Sensor, excludedSensorTypes, IValue, ApplianceTypes } from 'src/app/models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { Zone } from 'src/app/models/zone';
import { Appliance } from 'src/app/models/appliance';
import { DataService } from 'src/app/services/data.service';
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ZoneService } from '../../../services/zone.service';
import { ApiService } from "src/app/services/api.service";
import { MatDialog } from '@angular/material/dialog';
import { UpdateDialogComponent } from '../../clients/update-dialog/update-dialog.component';
import { DeleteDialogComponent } from '../../clients/delete-dialog/delete-dialog.component';
import { AuthService } from 'src/app/services/auth.service';
import { AddDialogComponent } from'../../clients/add-dialog/add-dialog.component';

export interface Category {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-gateways',
  templateUrl: './gateways.component.html',
  styleUrls: ['./gateways.component.less']
})
export class GatewaysComponent implements OnInit, OnDestroy {
  gateways: any | null = null;
  currentCompany: any = null
  currentCompanyId: string | null = null
  
  subscription: Subscription;
  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private socketService: SocketIoService,
    private zoneService: ZoneService,
    private _api: ApiService,
    public dialog: MatDialog,
    public authService: AuthService) {

      this.dataService.sharedCompany$.subscribe(company => {
        this.currentCompany = company;
      })

      this.dataService.sharedCompanyId$.subscribe(companyId => {
        this.currentCompanyId = companyId;
      })
  }

  ngOnInit(): void {
    this.getGateways();
  }

  

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  getGateways(){
    let company = this.currentCompanyId
    if (localStorage.getItem('currentCompany') && !this.currentCompanyId) {
      company = JSON.parse(localStorage.getItem('currentCompany'))._ic;
     
    }
    this._api.get<any>(`/gateway/company/${company}`).subscribe(resp => {
        this.gateways = resp.gateways;
    }, err => {
        alert(err.message);
    });
  }

  addNew(type: string){
    let title = type[0].toUpperCase() + type.slice(1)
    let data: any = {
        type: type,
        company: this.currentCompanyId,
        title: title,
        name: '',
        function: (item) => this.add(type, item)
      }

    
    const dialogRef = this.dialog.open(AddDialogComponent, {
        disableClose: true,
        data: data
        
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === undefined) return;
        setTimeout(() => result.name);
        this.getGateways();
      });
}

add(type: string, data: any) {
    if(type === 'cycle'){
        return this._api.post<any>(`/zone/${data.zone}/${type}`, {strainName: data.name, plantsQuantity: data.grow.plantsQuantity});
    }
    return this._api.post<any>(`/${type}`, data);
}

  editGateway(gateway) {
    const dialogRef = this.dialog.open(UpdateDialogComponent, {
      disableClose: true,
      data: {
        type: 'gateway',
        title: 'Gateway',
        name: gateway,
        function: (gateway) => this.updateZone('gateway', gateway)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => gateway.name = result.name);
      this.getGateways();
    });
  }

  deleteGateway(gateway){
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      disableClose: true,
      data: {
        type: 'gateway',
        title: 'Gateway',
        name: gateway.name,
        id:gateway._id,
        function: (gateway) => this.deleteOptions('gateway', gateway)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => gateway.name = result.name);
      this.getGateways();
    });
  }

  deleteOptions(type: string, gateway: any) {
    return this._api.delete(`/${type}/${gateway.id}`) 
  }

  updateZone(type: string, gateway: any) {
    return this._api.put<any>(`/${type}/${gateway.name._id}`, gateway.name);
  }

}
